import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	@media all and (max-width: ${variables.tabletS}) {
	}
`;
